import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { DeliveryType } from 'src/api/@generated/backend-api';

import { i18n } from 'src/i18n';
import { setDeliveryType } from 'src/state/order/order-slice';
import { selectDeliveryType } from 'src/state/order/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { PricingUtils } from 'src/utils/pricing-utils';
import { currency } from 'src/utils/currency-utils';
import { useProductsResponseQueryStateOrThrow } from 'src/hooks/use-products-query';

import { DeliveryMethod as DeliveryMethodComponent } from './delivery-method';
import { StyledContainer, StyledTitle } from './delivery-method-select.styled';

export const DeliveryMethodSelect: FunctionComponent = () => {
  const selectedDeliveryType = useAppSelector(selectDeliveryType);
  const dispatch = useAppDispatch();
  const { deliveryPricing } = useProductsResponseQueryStateOrThrow();
  const deliveryTypes: DeliveryType[] = ['HELTHJEM_IN_SHOP', 'HELTHJEM_TO_DOOR'];

  const renderDeliveryMethod = (deliveryType: DeliveryType) => {
    const deliveryPrice = PricingUtils.getDeliveryPrice(deliveryPricing, deliveryType);

    return (
      <DeliveryMethodComponent
        key={deliveryType}
        name={i18n.component.deliveryMethodSelect.deliveryMethod[deliveryType].name}
        description={i18n.component.deliveryMethodSelect.deliveryMethod[deliveryType].description}
        price={currency(deliveryPrice)}
        moreInformation={
          deliveryType === 'HELTHJEM_IN_SHOP'
            ? i18n.component.deliveryMethodSelect.deliveryMethod[deliveryType].info
            : undefined
        }
        onChange={() => dispatch(setDeliveryType(deliveryType))}
        checked={deliveryType === selectedDeliveryType}
      />
    );
  };

  return (
    <StyledContainer>
      <StyledTitle variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
        {i18n.component.deliveryMethodSelect.title}
      </StyledTitle>
      <div>{deliveryTypes.map(renderDeliveryMethod)}</div>
    </StyledContainer>
  );
};
